import React from 'react';
import ReactDOM from 'react-dom';
import Homepage from './Components/Homepage/Homepage';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Homepage />
  </React.StrictMode>,
  document.getElementById('root')
);

